import { styled } from '@volkswagen-onehub/components-core';

export const GeneralConfirmacionWrapper = styled.div`
  padding: 72px 0 44px;
  @media all and (min-width: 960px) {
    padding: 86px 0 0;
  }
`;

export const GeneralConfirmacionLayerWrapper = styled.div`
  padding: 72px 0 44px;
  @media all and (min-width: 960px) {
    padding: 86px 0 0;
  }
`;
